"use strict";

define(['marionette', './../templates/topic.html'], function (Marionette, tmplTopic) {
  return Marionette.ItemView.extend({
    template: tmplTopic,
    templateHelpers: function templateHelpers() {
      return {
        threadTitleIcon: this.getTitleIcon(),
        showCategory: this.options.showCategory
      };
    },
    getTitleIcon: function getTitleIcon() {
      var features = this.model.get('features');
      if (!features || !features.length) return '';

      if (features[0].id === 'isQuestion') {
        return 'question-circle';
      }

      if (features[0].id === 'isAnswered') {
        return 'thread-solved';
      }

      return '';
    }
  });
});